import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, bool_type, string_type, class_type, list_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Faq_AdminFaq_$reflection, Faq_AdminFaqListItem_$reflection, Faq_AdminFaqKategorieListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { FormField__get_IsValid, ValidationRule, FormField_Init_Z1F39563A, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Faq"];
    }
}

export function Page_$reflection() {
    return union_type("AdminFaq.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadKategorien", "KategorienLoaded", "LoadFaqList", "FaqListLoaded", "ActivateFaq", "DeactivateFaq", "ActiveChanged", "NewFaq", "LoadFaq", "FaqLoaded", "FrageChanged", "AntwortChanged", "PositionChanged", "AktivChanged", "KategorieChanged", "SichtbarFuerPflegeChanged", "SichtbarFuerPflegeDtaPlusChanged", "SichtbarFuerTherapieChanged", "SichtbarFuerJugendhilfeChanged", "Save", "Saved", "SavedNew", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminFaq.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Faq_AdminFaqKategorieListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Faq_AdminFaqKategorieListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["kategorieId", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Faq_AdminFaqListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Faq_AdminFaqListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["id", string_type]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["kategorieId", class_type("System.Guid")]], [["id", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Faq_AdminFaq_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Faq_AdminFaq_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", class_type("System.Guid")]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("System.Guid"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("System.Guid")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class EditModel extends Record {
    constructor(Id, Frage, Antwort, Position, Aktiv, SichtbarFuerPflege, SichtbarFuerPflegeDtaPlus, SichtbarFuerTherapie, SichtbarFuerJugendhilfe, KategorieId, Sending, IsDirty, TextAsHtml) {
        super();
        this.Id = Id;
        this.Frage = Frage;
        this.Antwort = Antwort;
        this.Position = Position;
        this.Aktiv = Aktiv;
        this.SichtbarFuerPflege = SichtbarFuerPflege;
        this.SichtbarFuerPflegeDtaPlus = SichtbarFuerPflegeDtaPlus;
        this.SichtbarFuerTherapie = SichtbarFuerTherapie;
        this.SichtbarFuerJugendhilfe = SichtbarFuerJugendhilfe;
        this.KategorieId = KategorieId;
        this.Sending = Sending;
        this.IsDirty = IsDirty;
        this.TextAsHtml = TextAsHtml;
    }
}

export function EditModel_$reflection() {
    return record_type("AdminFaq.Types.EditModel", [], EditModel, () => [["Id", option_type(class_type("System.Guid"))], ["Frage", FormField_$reflection()], ["Antwort", FormField_$reflection()], ["Position", FormField_$reflection()], ["Aktiv", bool_type], ["SichtbarFuerPflege", bool_type], ["SichtbarFuerPflegeDtaPlus", bool_type], ["SichtbarFuerTherapie", bool_type], ["SichtbarFuerJugendhilfe", bool_type], ["KategorieId", class_type("System.Guid")], ["Sending", bool_type], ["IsDirty", bool_type], ["TextAsHtml", string_type]]);
}

export function EditModel_Init(id, kategorieId) {
    return new EditModel(id, FormField_Init_Z1F39563A(new ValidationRule(2, [200])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(1, [])), true, false, false, false, false, kategorieId, false, false, "");
}

export function EditModel__get_CanSubmit(x) {
    if ((!x.Sending && FormField__get_IsValid(x.Frage)) && FormField__get_IsValid(x.Antwort)) {
        return FormField__get_IsValid(x.Position);
    }
    else {
        return false;
    }
}

export class Model extends Record {
    constructor(Kategorien, SelectedKategorie, Faqs, EditModel) {
        super();
        this.Kategorien = Kategorien;
        this.SelectedKategorie = SelectedKategorie;
        this.Faqs = Faqs;
        this.EditModel = EditModel;
    }
}

export function Model_$reflection() {
    return record_type("AdminFaq.Types.Model", [], Model, () => [["Kategorien", list_type(Faq_AdminFaqKategorieListItem_$reflection())], ["SelectedKategorie", option_type(class_type("System.Guid"))], ["Faqs", Remote$1_$reflection(list_type(Faq_AdminFaqListItem_$reflection()))], ["EditModel", option_type(EditModel_$reflection())]]);
}

//# sourceMappingURL=Types.fs.js.map
